import { FrontLoginForm } from '#theme';
import {
  AuthSource,
  ExternalUserLoginForm,
  MockLoginForm,
  useLogin,
} from '@framework/auth';
import { useHistory } from '@framework/ui';
import React from 'react';
import { appConfig, resolveApiPath } from '../../../core/appConfig';

interface Props {}

/**
 * Form di login all'applicativo, tramite le API di creazione AccessToken JWT.
 */
export function LoginForm(props: Props) {
  const history = useHistory();

  const onLogin = useLogin(history);

  // Form **reale** di login
  if (!appConfig.mockLogin) {
    return (
      <FrontLoginForm
        loading={false}
        resolvePublicUrl={resolveApiPath}
        onLogin={onLogin}
        externalLogin={<ExternalUserLoginForm onLogin={onLogin} />}
      />
    );
  }

  // Form **mock** di login
  return (
    <MockLoginForm source={AuthSource.FrontOffice}>
      <FrontLoginForm
        loading={false}
        resolvePublicUrl={resolveApiPath}
        externalLogin={<ExternalUserLoginForm onLogin={onLogin} />}
        onLogin={onLogin}
      />
    </MockLoginForm>
  );
}
